import sample_01 from './ergocareComfort.jpg';

export const ergocareComfortImpressions = {
    sample_01,
};
